import FieldAuto from './FieldAuto';
export default FieldAuto;
